// extracted by css-extract-rspack-plugin
export default {"ToggleContent":"jCLiw","isReadOnly":"NCj55"};